export const MAIN_NATIONS = [
  'CHN',
  'HKG',
  'MAC',
  'USA',
  'JPN',
  'THA',
  'AUS',
  'CAN',
  'ARE',
  'CHL',
  'NZL',
  'IDN',
  'SGP',
  'CHE',
  'DEU',
  'PHL',
  'RUS',
  'MYS',
  'GBR',
  'FRA',
  'VNM',
  'NLD',
  'IND',
  'ITA',
  'MEX',
  'TUR',
  'AUT',
  'SWE',
  'POL',
  'PRT',
  'ISL',
  'FIN',
  'ROU',
  'GRC',
  'TWN',
  'MNG',
  'SAU',
  'LVA',
  'BRA',
  'LKA',
  'KWT',
  'GTM',
  'TUN',
  'PER',
];

// 한국, 중국, 일본은 스위프트 코드 입력 필요 없음
export const DEFAULT_SWIFT_CODE_NATIONS = [
  'KOR',
  'CHN',
  'JPN',
  'USA',
  'THA',
  'SGP',
  'IDN',
  'DEU',
  'PHL',
  'MYS',
  'GBR',
  'FRA',
  'VNM',
  'NLD',
  'ITA',
  'IND',
  'CHE',
  'TUR',
  'AUT',
  'SWE',
  'POL',
  'PRT',
  'ISL',
  'FIN',
  'ROU',
  'GRC',
];

export const CASH_PICKUP_NATIONS = [
  'TWN',
  'MNG',
  'SAU',
  'LVA',
  'BRA',
  'LKA',
  'KWT',
  'GTM',
  'TUN',
  'PER',
];
